import React, { MouseEventHandler } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ProductDetailInfo } from "../ProductDetailPageTypeConfig";
import { Validation } from "../../localization/localeValidation";
import ajaxClient from "../../../../js/common/AjaxClient";

interface ProductErrorReportFormProperties {
    readonly productDetailInfo: ProductDetailInfo;
    readonly onShowQuestionForm: () => void;
    readonly onSubmitted: () => void;
}

interface SubmitErrorResponse {
    error: boolean;
    message: string;
}

const formSchema = yup.object({
    email: yup.string()
        .default("")
        .lowercase()
        .trim()
        .matches(Validation.EmailRegEx, { excludeEmptyString: true, message: "Zadejte prosím platný e-mail" }),
    message: yup.string()
        .trim()
        .required("Zadejte prosím Vaši připomínku.")
        .min(8, "Vaše připomínka musí mít alespoň 8 znaků."),
});
type FormData = yup.InferType<typeof formSchema>;

const sendErrorReport = async function(productDetailInfo: ProductDetailInfo, data: FormData): Promise<void> {
    await ajaxClient.post<SubmitErrorResponse>(
        "/Product/jsSubmitError",
        {
            productId: productDetailInfo.productId,
            productTitle: productDetailInfo.title,
            productRewriteTitle: productDetailInfo.rewriteTitle,
            message: data.message,
            email: data.email,
            control: "",
            control2: "val2",
        },
    );
};

export default function ProductErrorReportForm({
    productDetailInfo,
    onShowQuestionForm,
    onSubmitted,
}: ProductErrorReportFormProperties): React.JSX.Element {
    const { register, handleSubmit, formState: { errors } } = useForm<FormData>({
        resolver: yupResolver(formSchema),
    });
    const onSubmit: SubmitHandler<FormData> = async (data: FormData): Promise<void> => {
        await sendErrorReport(productDetailInfo, data);
        onSubmitted();
    };

    const handleOpenQuestionForm: MouseEventHandler<HTMLAnchorElement> = (event): void => {
        event.preventDefault();
        onShowQuestionForm();
    };

    return (
        <div className="modal-body">
            <div className="well well-transparent">
                <div className="product-row">
                    <p className="fakeh3">Nalezli jste v ceně nebo popisu chybu?</p>
                    <div className="error-submit">
                        <div className="error-submit-right">
                            <img src="/css/image/karel-kruh.png" alt="" loading="lazy" />
                            <p>Dejte mi, prosím, vědět. I díky Vám se mohu stále
                                zlepšovat.
                            </p>
                            <p>Pokud chcete spíše položit dotaz ke zboží, využijte formulář
                                &nbsp;<a
                                className="cursor-pointer "
                                onClick={handleOpenQuestionForm}>Dotaz ke zboží
                            </a>.
                            </p>
                        </div>
                        <div className="error-submit-form">
                            <form onSubmit={(event): void => void handleSubmit(onSubmit)(event)}>
                                <div className="all-modal-width">
                                    <label htmlFor="errorSub_message-id">Popis chyby / komentář /
                                        připomínka
                                    </label>
                                    <textarea
                                        id="errorSub_message-id" {...register("message")}
                                        placeholder="Zadejte připomínku / komentář"
                                        cols={40} rows={5}>
                                    </textarea>
                                    <label htmlFor="errorSub_message-id" className="error">{errors.message?.message}</label>
                                </div>

                                <div className="all-modal-width">
                                    <label htmlFor="error_sub_email-id">Váš
                                        e-mail
                                    </label>
                                    <span> (nepovinné)</span>
                                    <input
                                        id="error_sub_email-id" type="text" {...register("email")}
                                        placeholder="Zadejte platný e-mail" />
                                    <label htmlFor="error_sub_email-id" className="error">{errors.email?.message}</label>
                                </div>

                                <div className="submit-wide-button">
                                    <button type="submit" className="btn btn-success btn-md">Odeslat
                                        připomínku
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
